/* eslint-disable operator-linebreak */
/* eslint-disable arrow-body-style */
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { getAccessToken } from './firebase';
import { showMessage } from 'redux/actions';

const fileService = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    // Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

const fileUploadService = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

fileService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response.status === 401 &&
      error.response.data.errors &&
      error.response.data.errors[0].code === 'INVALID_TOKEN'
    ) {
      // return AuthService.updateAccessToken().then((accessToken) => {
      //   error.config.headers.Authorization = `Bearer ${accessToken}`;
      //   return apiClient.request(error.config);
      // });
    }
    return Promise.reject(error);
  },
);

fileUploadService.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

const listFiles = async () => {
  const accessToken = await getAccessToken();

  try {
    const apiURL = `/user_file`;
    const result = await fileService.get(apiURL, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    return result.data;
  } catch (error) {
    return { error: true };
  }
};

// use React Query
export const useGetListFiles = (params) => {
  const dispatch = useDispatch();

  return useQuery(['LIST_FILES', params], () => listFiles(params), {
    onError: (error) => {
      dispatch(
        showMessage({ type: 'error', message: 'There was an error fetching the file list.' }),
      );
    },
  });
};

const uploadFile = async (file) => {
  const accessToken = await getAccessToken();

  try {
    const apiURL = `/user_file`;

    // Create a FormData object to properly handle file uploads
    const formData = new FormData();
    formData.append('file', file);

    const result = await fileUploadService.post(apiURL, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        // Content-Type will be set automatically with the correct boundary by the browser
      },
    });

    return result.data;
  } catch (error) {
    return { error: true };
  }
};

// use React Query POST
// POST
// /api/v1/beta/user_file
// User Upload File

// Upload a file for the authenticated user.

// Endpoint: POST /user_file Description:

// Checks if a file with the same name already exists for the current user.
// If not, uploads the file to the storage backend under user_file/{user_id}/{filename}.
// Records a user_file entry in the database with the file metadata.
// Request Parameters:

// file (UploadFile): The file to upload.
// Dependencies:

// db: Synchronous SQLAlchemy session for writing metadata.
// async_db: Asynchronous database client for pre-check.
// user: The current authenticated user.
// Responses:

// 200 OK: File uploaded successfully.
// 400 File Name Already Exists: A file with the same name already exists for this user.
// 500 Internal Server Error: An unexpected error occurred during processing.

// Request body

// multipart/form-data
// file *
// string($binary)

export const useUploadFile = () => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const handleSuccess = () => {
    queryClient.invalidateQueries(['LIST_FILES']);
    dispatch(showMessage({ type: 'success', message: 'File uploaded successfully.' }));
  };

  return useMutation((file) => uploadFile(file), {
    onSuccess: handleSuccess,
    onError: (error) => {
      dispatch(showMessage({ type: 'error', message: 'There was an error uploading the file.' }));
    },
  });
};

const overwriteFile = async ({ userFileId, file }) => {
  const accessToken = await getAccessToken();

  const formData = new FormData();
  formData.append('file', file);

  const result = await fileUploadService.put(`/user_file/${userFileId}`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.data;
};

export const useOverwriteFile = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(({ userFileId, file }) => overwriteFile({ userFileId, file }), {
    onSuccess: () => {
      queryClient.invalidateQueries(['LIST_FILES']);
      dispatch(showMessage({ type: 'success', message: 'File overwritten successfully.' }));
    },
    onError: () => {
      dispatch(showMessage({ type: 'error', message: 'There was an error overwriting the file.' }));
    },
  });
};
